import { ExpandAllOutlineIcon } from './ExpandAllOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 934C9329-AC58-499E-BE89-A5E43FA71C6F
 * name expand-all-outline
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/expand-all-outline.svg
 * tags
 */
export const AnimationPlusOutlineIcon = ExpandAllOutlineIcon;
export default AnimationPlusOutlineIcon